import { useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react';
import { useEdit } from '../../Services/EditContext';
import {  useFetchEntity } from '../../Services/fetchApi';
import { endpoints } from '../../utils/Constants';
import { FormLabel, FormValue } from './FormLabel';
import ErrorMessage from './ErrorMessage'
import Selector from './Selector';
const AircraftCategorySelector = (props) => {
    const { label, id, ...myProps } = props;
    const [selection, setSelection] = useState();
    const [options, setOptions] = useState();
    const { setFieldValue, values } = useFormikContext();

    const [aircraft, loading, error] = useFetchEntity({name: "AircraftCategories", getByStatus: () => endpoints.getAircraftCategories});
    const value = values[id];
    const [edit] = useEdit();
   

    useEffect(() => {

        const options = aircraft ? aircraft.map((m) => { return { id: m.id, value: m.id, label: m.categoryName }; }) :null;
        setOptions(options)
    }, [aircraft]);

    useEffect(() => {
        if (options) {
            if (value) {
                setSelection(options.filter(x => { return value === x.label })[0]);
            }
            else {
                setSelection()
            }
        }
    }, [value, options]);

    const onSelectChange = val => {
         setFieldValue(id, val.label);
    }
    return <React.Fragment>
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            {label}
        </FormLabel>
        {error ? <h4>Error Loading categories</h4> : null}
        {edit && !loading ? <Selector size='sm' onChange={onSelectChange} value={selection} options={options} {...myProps} /> : <FormValue>{selection ? selection.label : null}</FormValue>}
        <ErrorMessage name={id} />
    </React.Fragment>
};
export default AircraftCategorySelector;

